import { useEffect, useState } from "react";
import PageBanner from "@/components/PageBanner";
import Ornament from "@/components/Ornament";
import { MENU, MENU_CATEGORIES } from "@/data/menu";

export default function Meniu() {
  const [active, setActive] = useState("aperitive");

  // Track scroll to update active tab
  useEffect(() => {
    const onScroll = () => {
      const sections = MENU_CATEGORIES.map((c) =>
        document.getElementById(`section-${c.id}`)
      );
      const offset = 200;
      let current = MENU_CATEGORIES[0].id;
      for (const sec of sections) {
        if (!sec) continue;
        const top = sec.getBoundingClientRect().top;
        if (top - offset <= 0) {
          current = sec.id.replace("section-", "");
        }
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(`section-${id}`);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - 160;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <div data-testid="page-meniu">
      <PageBanner
        overline="La Carte"
        title="Meniul Nostru"
        subtitle="Preparate cu suflet, create pentru momente speciale."
        testId="meniu-banner"
      />

      {/* Sticky category tabs */}
      <div
        data-testid="menu-tabs"
        className="sticky top-20 md:top-24 z-40 bg-brand-night/95 backdrop-blur-md border-y border-brand-gold/15"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-10 lg:px-16">
          <div className="flex items-center gap-2 md:gap-6 overflow-x-auto py-4 no-scrollbar">
            {MENU_CATEGORIES.map((c) => (
              <button
                key={c.id}
                type="button"
                data-testid={`menu-tab-${c.id}`}
                onClick={() => scrollTo(c.id)}
                className={`relative whitespace-nowrap px-3 md:px-4 py-2 font-sans text-[11px] md:text-[12px] tracking-[0.3em] uppercase transition-colors duration-300 ${
                  active === c.id
                    ? "text-brand-gold"
                    : "text-brand-ivory/60 hover:text-brand-gold"
                }`}
              >
                {c.label}
                <span
                  className={`absolute left-3 right-3 -bottom-1 h-px transition-transform duration-500 origin-left ${
                    active === c.id ? "bg-brand-gold scale-x-100" : "bg-brand-gold scale-x-0"
                  }`}
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Menu sections */}
      <div className="bg-brand-night">
        {MENU_CATEGORIES.map((cat) => (
          <section
            key={cat.id}
            id={`section-${cat.id}`}
            data-testid={`menu-section-${cat.id}`}
            className="py-20 md:py-28 scroll-mt-40"
          >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
              <div className="text-center mb-14">
                <span className="reveal block text-[11px] tracking-[0.4em] uppercase text-brand-gold mb-4 font-sans">
                  Selecţia Maison
                </span>
                <h2 className="reveal font-serif text-4xl sm:text-5xl md:text-6xl text-brand-ivory italic">
                  {cat.label}
                </h2>
                <div className="reveal mt-8">
                  <Ornament />
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-10 max-w-6xl mx-auto">
                {MENU[cat.id].map((item, i) => (
                  <article
                    key={item.name}
                    data-testid={`menu-item-${cat.id}-${i}`}
                    className="reveal group border-b border-brand-gold/15 pb-7"
                  >
                    <div className="flex items-baseline justify-between gap-6">
                      <h3 className="font-serif text-xl md:text-2xl text-brand-gold leading-snug group-hover:text-brand-goldHover transition-colors">
                        {item.name}
                      </h3>
                      <span className="font-serif font-medium text-lg md:text-xl text-brand-gold whitespace-nowrap">
                        {item.price}
                      </span>
                    </div>
                    <p className="mt-3 font-sans text-[14.5px] leading-relaxed text-brand-ivory/65 max-w-md">
                      {item.desc}
                    </p>
                  </article>
                ))}
              </div>
            </div>
          </section>
        ))}
      </div>

      {/* Footer note */}
      <div className="py-16 bg-brand-deep border-t border-brand-gold/10 text-center px-6">
        <p className="reveal font-serif italic text-brand-ivory/60 max-w-2xl mx-auto">
          „Bucătăria este limba prin care vă spunem că ne pasă.”
        </p>
        <p className="reveal mt-3 text-[11px] tracking-[0.4em] uppercase text-brand-gold font-sans">
          — Chef Antoine Laurent
        </p>
      </div>
    </div>
  );
}
